export default "__VITE_ASSET__A7QlU2NE__"